<template>
    <div class="container">
        <banner
            :title="pageData.banner.name"
            :mess="pageData.banner.mess"
            :describe="pageData.banner.describe"
            :imgUrl="pageData.banner.imgUrl"
            :link="link"
        />
        <product-service-section title="品牌痛点" :data-list="pageData.solutionData" :has-link="false" :pageKey="pageData.key"/>
        <polution-part :polution-data="pageData.polution"></polution-part>
        <product-features :data="pageData.featureData"/>
        <product-advantage-row :advantage-data="pageData.advantageData" :pageKey="pageData.key"/>
        <productExcellentCase :text="'优秀案例'" :excellent-data="pageData.excellentData" />
    </div>
</template>
<script>
import banner from "../../components/banner.vue";
import productServiceSection from "../../components/productServiceSection.vue";
import productFeatures from "./productFeatures.vue";
import productExcellentCase from "../../components/productExcellentCase.vue";
import productAdvantageRow from "./productAdvantageRow.vue";
import polutionPart from "./polutionPart.vue";
export default {
  name: "product",
  components: {
    banner,
    productServiceSection,
    productFeatures,
    productAdvantageRow,
    productExcellentCase,
    polutionPart
  },
  data() {
    return {
      pageConfig: {
        "/cloud/cdp": {
          key: 'cdp',
          banner: {
            name: "经营增长",
            mess:'商智 × 数坊 × 京东消息类产品',
            describe:
              "通过经营数据洞察与分析，分析自身生意经营状况，刻画行业趋势，制定个性化运营策略",
            imgUrl:
              "//img10.360buyimg.com/img/jfs/t1/177591/12/52817/72412/67468b2fFba4b15c4/07b051c8971af8ae.jpg"
          },
          polution:{
            mess:"基于经营全场景数据的多维洞察，通过策略制定与精细运营，助力生意增长",
            imgUrl:"//img10.360buyimg.com/img/jfs/t1/260075/21/14288/417986/678f32ceFf982b3fb/284170e43a1f6f0e.png"
          },
          solutionData: [
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/149911/12/49230/27602/6745c644Fc730c361/b3df5c4fb49210ea.png",
              name: "如何全面了解生意经营数据",
              describe:
                "品牌及商家需要知己知彼，除自身经营状况分析外，也需要实时了解行业大盘数据和趋势走向。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/248785/22/26220/21682/6745c680F0215cf10/242d37a4cff762aa.png",
              name: "如何洞察数据并实现生意增长",
              describe:
                "如何通过数据洞悉商机，找到趋势品类/商品并获得流量机会以推动生意增长。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/151567/11/44908/22931/6745c69dFcaafed69/2b786c9d7fa2671b.png",
              name: "如何精细营销促进用户转化",
              describe:
                "海量用户需求难以准确把握，目标人群难以实现针对性营销转化。"
            }
          ],
          featureData: {
              backImg: '//img10.360buyimg.com/img/jfs/t1/221516/33/48305/942661/6745c6d4F753de95d/aaf9309b4dcd5714.png',
              productDataList: [
                  {
                      name: '全链路经营数据开放',
                      content: '商智为品牌及商家提供全链路经营数据分析，包含自身流量、商品、交易、营销及行业动向等。'
                  },
                  {
                      name: '个性化数智服务',
                      content: '商智针对中小品牌及商家降低用数门槛，提供易懂的经营策略及运营操作建议；针对头部品牌及商家提升数据丰富度和灵活性，支持自定义探索分析能力，提供咨询诊断及策略输出。'
                  },
                  {
                      name: '用户营销转化闭环',
                      content: '以5A消费者生命周期模型为基础，数坊连接文本短信、富媒体短信、咚咚消息、智能消息、外呼等多元触点，构建用户洞察、客群挖掘分析、消费者分层触达、全局营销效果追踪为一体的用户运营闭环。'
                  }
              ]
          },
          advantageData: [
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/186571/8/51732/25081/6745c720F137f726a/d948ace67365d829.png',
                  name: '京东站内外全链路数据',
                  content: '整合站内外丰富的消费者行为数据，实现广告、内容、电商行为、社交裂变等电商链路覆盖。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/218089/6/49752/23526/6745c73bFf8c9747a/8df70d605dbf87a3.png',
                  name: '强大数据底层及算法支撑',
                  content: '数据实时更新，诊断策略智能生成；行竞趋势一目了然，蓝海商机抢先识别。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/167829/39/50548/170416/6745c751F9ed70697/63a612bffcf8e48d.png',
                  name: '成熟的用户资产模型和智能算法',
                  content: '拥有长期积累的电商运营经验和得到充分效果验证的5A用户模型，科学指导用户运营策略；并凭借智能算法模型，对用户进行聚类分析、分层运营。'
              }
          ],
          excellentData: [
            {
              img: '//img10.360buyimg.com/img/jfs/t1/180074/20/54013/362142/6745a6d1Fd6de50bb/c204e284c6d77065.png',
              title: '数智化人货场策略，引爆机械革命618销售',
              contentTitle: '品牌诉求:',
              contentMess:'了解用户需求，实现拉新转化',
              CTitle:'解决方案：',
              CArray:['1）“人货场”洞察：已购用户分析，聚焦潜力人群与重点提升项，锁定主推型号，优化策略布局；','2）营销落地：以用户洞察指导广告创意；站内用户分层营销；精准匹配权益。'],
              footer: [
                {
                  key: '月度GMV',
                  value: '120%'
                },
                {
                  key: 'ROI提升至行业',
                  value: '2.4倍'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/235268/16/28267/282488/6745a73aFcb2f7c98/bce7837041319b8c.png',
              title: '伊利金领冠婴儿粉618精细运营',
              contentTitle: '品牌诉求:',
              contentMess:'依靠用户增长带动GMV增长',
              CTitle:'解决方案：',
              CArray:['1）商智系统诊断：了解品类特征和店铺健康度；','2）商品结构优化：确定引流款、中高端款等；','3）商智×京准通，提升商品权重，付费带动免费；','4）数坊×京准通，提升用户精细化运营和触达。'],
              footer: [
                {
                  key: 'GMV',
                  value: '3%'
                },
                {
                  key: '成交客单价',
                  value: '29%'
                }
              ]
            }
          ]
        },
        "/cloud/dsp": {
          key: 'dsp',
          banner: {
            name: "用户增长",
            mess:'营销云 - 天链 × 会员通',
            describe:
              "通过全域用户识别及洞察分析，帮助品牌实现全域消费者资产管理和精细化运营，实现全域用户增长",
            imgUrl:
              "//img10.360buyimg.com/img/jfs/t1/266434/3/178/39996/676394e8Fd367c782/6c8efa26be5fd356.jpg"
          },
          polution:{
            mess:"整合品牌全域用户，从融通、洞察、挖掘到权益匹配，实现全域用户沉淀与运营提效",
            imgUrl:"//img10.360buyimg.com/img/jfs/t1/233615/35/28786/372059/678f32ceFec67c31e/5a89c2fc002e38fa.png"
          },
          solutionData: [
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/149911/12/49230/27602/6745c644Fc730c361/b3df5c4fb49210ea.png",
              name: "如何高效管理多域用户资产",
              describe:
                "品牌跨域用户数据分散，难以对全域用户资产进行统一管理、对全域用户特征进行全视角洞察。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/186571/8/51732/25081/6745c720F137f726a/d948ace67365d829.png",
              name: "如何一体化分层运营全域用户",
              describe:
                "各域消费者数据融合及特征标签不一致，难以对全域用户进行精准分层运营和权益匹配。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/151567/11/44908/22931/6745c69dFcaafed69/2b786c9d7fa2671b.png",
              name: "如何高效触达全渠道用户",
              describe:
                "多域运营场不互通，跨域营销成本高，难以兼顾全域营销触点。"
            }
          ],
          featureData: {
              backImg: '//img10.360buyimg.com/img/jfs/t1/221516/33/48305/942661/6745c6d4F753de95d/aaf9309b4dcd5714.png',
              productDataList: [
                  {
                      name: '全域用户身份融通',
                      content: '天链在数据安全前提下，实现各业务全渠道用户资产整合，结合京东数据能力，助力品牌一体化用户洞察和管理。'
                  },
                  {
                      name: '智能挖掘机会用户',
                      content: '结合品牌一方数据与京东数据，营销云策略引擎智能提炼高价值用户特征并搭建特征模型，生成策略人群、匹配对应权益，打造全渠道统一的品牌体验，提升站内交易。'
                  },
                  {
                      name: '多触点激活全渠道用户',
                      content: '在京东营销场域内聚合全渠道用户，天链连接京东站内外营销触点，一站式实现全渠道用户的全域触达。'
                  }
              ]
          },
          advantageData: [
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/218089/6/49752/23526/6745c73bFf8c9747a/8df70d605dbf87a3.png',
                  name: '多接口用户信息安全打通',
                  content: '多种对接方式可选，实现全渠道用户信息安全融通，灵活满足品牌需求。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/167829/39/50548/170416/6745c751F9ed70697/63a612bffcf8e48d.png',
                  name: '多维度立体用户洞察',
                  content: '提供RFM、5A等用户分层模型分析及品牌自定义标签分析，对用户特征、行为、意向等进行多维度立体洞察。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/248785/22/26220/21682/6745c680F0215cf10/242d37a4cff762aa.png',
                  name: '多场域用户权益触达',
                  content: '用户运营场域升级，包含PUSH、首页站内信等触点资源，覆盖从用户召回、进站、浏览到离站的全链路。'
              }
          ],
          excellentData: [
            {
              img: '//img10.360buyimg.com/img/jfs/t1/242668/4/16017/164854/6745a7bcFacb55e02/a3201d29fe9bc739.png',
              title: '伊利金领冠×京东营销云：共筑数据安全应用新高度',
              contentTitle: '品牌诉求:',
              contentMess:'储存、计算、实时更新上亿全域数据；科学匹配货品和媒介，实现生意增长',
              CTitle:'解决方案：',
              CArray:['1）部署京东TEE安全岛，数据安全融合计算；','2）品牌用户精细分层，人货智能匹配，科学组合多场景营销触点。'],
              footer: [
                {
                  key: '新客数',
                  value: '83%'
                },
                {
                  key: '老客复购率',
                  value: '19%'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/190210/6/53229/310461/6745a7f0F507c0826/1b78adbb18b80fc7.png',
              title: '跨域运营用户，Teenie Weenie双11再创新高',
              contentTitle: '品牌诉求:',
              contentMess:'沉睡用户触达唤醒，寻找最佳转化人群',
              CTitle:'解决方案：',
              CArray:['1）品牌用户身份归一，实现全域用户数据资产统一管理；','2）全域用户洞察与价值分层；','3）智能挖掘核心人群，京东公域资源及时干预。'],
              footer: [
                {
                  key: 'GMV',
                  value: '5%'
                },
                {
                  key: '广告ROI',
                  value: '近19倍'
                }
              ]
            }
          ]
        },
        "/cloud/dmp": {
          key: 'dmp',
          banner: {
            name: "营销提效",
            mess:'乘风计划 | 营销云 - RTA智能营销 × 全域监测 × 内容营销',
            describe:
              "通过数据能力，助力品牌在媒体投放、内容营销等场景进行站内外流量联动，实现营销提效",
            imgUrl:
              "//img10.360buyimg.com/img/jfs/t1/256347/26/1289/44686/67639544F0af7452b/f98beb396d167e80.jpg"
          },
          polution:{
            mess:"打通营销前后链路，联动平台资源，提升站外引流与站内转化效率",
            imgUrl:"//img10.360buyimg.com/img/jfs/t1/258881/23/14251/279203/678f32cfFe5d617d1/d443331a7e48bf5e.png"
          },
          solutionData: [
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/149911/12/49230/27602/6745c644Fc730c361/b3df5c4fb49210ea.png",
              name: "如何追踪媒体投放的长效价值",
              describe:
                "品牌媒体投放前后链路数据割裂，无法综合、准确评估媒体效果。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/186571/8/51732/25081/6745c720F137f726a/d948ace67365d829.png",
              name: "如何快速响应优化媒体策略",
              describe:
                "跨平台多触点投放分散决策力，难以对各触点策略实时调优，且策略调度响应链路长，影响优化效率。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/187050/24/53484/24852/67468499F566c171c/a3d95c75a1159282.png",
              name: "如何持续营销强化品效",
              describe:
                "难以在电商场域精准承接广告触达与种草人群，进行再营销，营销转化效果不理想。"
            }
          ],
          featureData: {
              backImg: '//img10.360buyimg.com/img/jfs/t1/221516/33/48305/942661/6745c6d4F753de95d/aaf9309b4dcd5714.png',
              productDataList: [
                  {
                      name: '投放全链路数据评估媒体效果',
                      content: '通过全域监测自动回流站外投放数据，并与京东域数据打通，提供全链路数据指标，全面评估营销转化效果。'
                  },
                  {
                      name: '多域媒体流量持续运营调优',
                      content: '通过全域监测的媒体全链路效果分析，RTA流量实时判断能力，帮助品牌及时调整媒体投放策略和人群定向策略。'
                  },
                  {
                      name: '用户回流再营销放大流量价值',
                      content: '沉淀、联动全渠道营销触点的用户数据，营销云策略引擎智能生成策略人群，通过京准通再营销，实现多场景、全链路的营销能力串联。'
                  }
              ]
          },
          advantageData: [
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/218089/6/49752/23526/6745c73bFf8c9747a/8df70d605dbf87a3.png',
                  name: '多端多媒体对接回流数据',
                  content: '支持跨屏跨设备、跨平台的效果追踪，打通抖音、小红书、腾讯视频等媒体与京东数据，帮助品牌全面监测媒体效能。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/167829/39/50548/170416/6745c751F9ed70697/63a612bffcf8e48d.png',
                  name: '高潜用户智能识别',
                  content: '针对站外回流人群，结合京东域内行为，利用京东算法模型，识别高潜人群，智能生成策略，助力品牌提升转化效率。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/248785/22/26220/21682/6745c680F0215cf10/242d37a4cff762aa.png',
                  name: '权益补贴强化站内外联动',
                  content: '基于流量扶持计划（乘风计划），给予品牌优质站内联动资源权益；结合用户媒体和电商行为，匹配干预触点，促进用户转化。'
              }
          ],
          excellentData: [
            {
              img: '//img10.360buyimg.com/img/jfs/t1/221069/33/49922/512230/6745a813F4fc5ca6e/8e23c40e27cb6029.png',
              title: '抖音种草数据回流与跨域应用，君乐宝高效拉新',
              contentTitle: '品牌诉求:',
              contentMess:'内容营销的后链路转化和实际销量增长',
              CTitle:'解决方案：',
              CArray:['1）抖音种草数据回流与洞察：回流人群28xx万人，分品类进行市场分析、用户来源分析等；','2）增量人群挖掘与再营销：智能挖掘策略人群，推送京准通再营销。'],
              footer: [
                {
                  key: '新客数是对照组',
                  value: '7倍'
                },
                {
                  key: '总曝光',
                  value: '1亿'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/248969/11/24250/366832/6745a84cFb6d657e9/8170de81f1f5aed9.png',
              title: '乘风计划赋能宝洁站内外用户及时联动，提升全域营销运营效率',
              contentTitle: '品牌诉求:',
              contentMess:'联动站外曝光和站内触达，拉升曝光转化',
              CTitle:'解决方案：',
              CArray:['1）RTA智能营销助力站外媒体投放提效；','2）营销云策略引擎智能挖掘高潜用户；','3）“乘风计划”拉通京东平台资源，及时联动站内外用户，提升全域营销规模和效率。'],
              footer: [
                {
                  key: 'UV引入',
                  value: '116%'
                },
                {
                  key: 'GMV',
                  value: '351%'
                }
              ]
            }
          ]
        },
        "/cloud/rta": {
          key: 'rta',
          banner: {
            name: "新品创新",
            mess:'京洞察 | 新品孵化中心',
            describe:
              "通过大小数据消费者洞察能力，联合行业伙伴为品牌提供一站式新品创新解决方案，缩短新品到爆品的路径",
            imgUrl:
              "//img10.360buyimg.com/img/jfs/t1/260744/4/178/45319/6763951aFd570e0f2/0ecbe10ca17238e4.jpg"
          },
          polution:{
            mess:"集大数据洞察、小数据调研于一体，从孵化新品到打爆新品全链路赋能",
            imgUrl:"//img10.360buyimg.com/img/jfs/t1/266564/40/14398/342333/678f32cfF55c3cb84/9b59937eeee0162f.png"
          },
          solutionData: [
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/186571/8/51732/25081/6745c720F137f726a/d948ace67365d829.png",
              name: "如何挖掘新品蓝海市场",
              describe:
                "在竞争激烈、增长缓慢的市场行情下，品牌难以快速找到增长潜力大且竞争相对小的新兴市场，实现引领性增长。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/151567/11/44908/22931/6745c69dFcaafed69/2b786c9d7fa2671b.png",
              name: "如何定位新品创新方向",
              describe:
                "新品潮流趋势研判难，产品研发难抓准用户痛点与真实反馈，难以科学定位产品具体创新卖点。"
            },
            {
              logoUrl:
                "//img10.360buyimg.com/img/jfs/t1/187050/24/53484/24852/67468499F566c171c/a3d95c75a1159282.png",
              name: "如何快速优化上新策略",
              describe:
                "消费者行为与喜好动态变化，难以敏捷制定多场景的最优沟通策略。"
            }
          ],
          featureData: {
              backImg: '//img10.360buyimg.com/img/jfs/t1/221516/33/48305/942661/6745c6d4F753de95d/aaf9309b4dcd5714.png',
              productDataList: [
                  {
                      name: '深度洞察品类趋势和消费趋势',
                      content: '提供品类洞察、关联洞察、销地爆品、转化漏斗、舆情监控等多维度洞察工具，全面解析消费者特征、捕捉消费趋势，为品牌新品方向提供反向策略指导。'
                  },
                  {
                      name: '多维立体助力全周期新品创新',
                      content: '提供覆盖定位期、研发期、上市前及上市后各阶段的品类趋势洞察、产品概念验证、外观包装测试及首发策略等一体化数字化能力。'
                  },
                  {
                      name: '多快好准，敏捷执行',
                      content: '上百家品牌验证的成熟数字化平台，为合作品牌提供多快好准的专业服务。'
                  }
              ]
          },
          advantageData: [
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/167829/39/50548/170416/6745c751F9ed70697/63a612bffcf8e48d.png',
                  name: '海量真实数据及科学算法提升洞察力',
                  content: '利用海量消费者行为数据及态度数据，科学算法实现需求洞察、趋势洞察和体验洞察。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/149911/12/49230/27602/6745c644Fc730c361/b3df5c4fb49210ea.png',
                  name: '专业成熟的开放平台',
                  content: '依托京东核心技术和各类型合作伙伴行业know-how，提供成熟洞察工具和新品创新解决方案。'
              },
              {
                  img: '//img10.360buyimg.com/img/jfs/t1/218089/6/49752/23526/6745c73bFf8c9747a/8df70d605dbf87a3.png',
                  name: '融合行业专业测试模型',
                  content: 'PSM、MaxDiff、仿真、智能PK等多场景模型能力搭建，科学快速遴选沟通策略。'
              }
          ],
          excellentData: [
            {
              img: '//img10.360buyimg.com/img/jfs/t1/224256/25/30916/364643/6745a872F71cb7e40/9619504b8a0e2f03.png',
              title: '美的Udmini热水器新品上市营销与分析',
              contentTitle: '品牌诉求:',
              contentMess:'卖点挖掘，提升新品销售转化',
              CTitle:'解决方案：',
              CArray:['1）通过消费者调研、大数据分析，结合站内行业品牌推广活动及流量分析，定向诊断新品问题；','2）联动外媒数据和京东数据，营销云策略引擎生成高点击高意向人群，在京准通实现高效再营销。'],
              footer: [
                {
                  key: '加购成本',
                  value: '26%'
                },
                {
                  key: 'ROI',
                  value: '27%'
                }
              ]
            },
            {
              img: '//img10.360buyimg.com/img/jfs/t1/222058/21/49296/353977/6745a892F6b1c9572/55e0a1c3fbf6f8f2.png',
              title: '新需求引领新发展，须尽欢冰淇淋首秀黑科技',
              contentTitle: '品牌诉求:',
              contentMess:'打造新概念产品，提高新品成功确定性',
              CTitle:'解决方案：',
              CArray:['1）通过用户调研，确认新品研发方向；','2）确认核心卖点，定位“全国首款低GI冰淇淋”；','3）京优选PK测试，确定包装设计；','4）产品试吃派样，了解客户反馈。'],
              footer: [
                {
                  key: '北上广市场份额',
                  value: '33%'
                },
                {
                  key: '销售额',
                  value: '45%'
                }
              ]
            }
          ]
        },
      },
      pageData: {
        banner: {
          name: "",
          describe: "",
          imgUrl: "",
        },
        solutionData: [],
        featureData: [],
        advantageData: [],
      },
      link:'',
      router:'加入我们'
    };
  },
  watch: {
    $route: {
      handler(val) {
        this.pageData = this.pageConfig[val.path] || this.pageData;
      },
      immediate: true
    }
  },
  mounted(){
    this.link = `${window.location.origin}/cloud/about/us`
  }
};
</script>